export const dict = {
  es: {
    nav: {
      services: "Servicios",
      cases: "Casos de éxito",
      about: "Nosotros",
      process: "Proceso",
      blog: "Recursos",
      switch: "cambiar idioma",
      cta: "Agenda una asesoría",
    },
    hero: {
      eyebrow: "Inteligencia Artificial · Neuromarketing · Estrategia 360°",
      title1: "El nuevo estándar",
      title2: "del crecimiento",
      title3: "comercial con IA.",
      subtitle:
        "Integramos inteligencia artificial, automatización, marketing, ventas y experiencia del cliente en un sistema único. Estrategia con visión humana — resultados de nivel ejecutivo.",
      cta_primary: "Agenda una asesoría",
      cta_secondary: "Ver casos de éxito",
      stat1: "+14 años",
      stat1_label: "creando líderes de mercado",
      stat2: "+320%",
      stat2_label: "conversión promedio en clientes",
      stat3: "24/7",
      stat3_label: "automatización con IA + WhatsApp",
      scroll_hint: "desliza para activar la IA",
      act3_eyebrow: "· Listo para el siguiente nivel ·",
      act3_title1: "Convierte tu negocio en un sistema",
      act3_title2: "impulsado por IA",
      badges: {
        b1: "+320% Conversión",
        b1_sub: "Embudo IA",
        b2: "Automatización IA",
        b2_sub: "Sistema activo",
        b3: "Inteligencia de Leads",
        b3_sub: "Scoring en tiempo real",
        b4: "WhatsApp IA",
        b4_sub: "Respuesta < 30s",
        b5: "CRM Conectado",
        b5_sub: "Sincronizado",
      },
    },
    services: {
      eyebrow: "PILARES ESTRATÉGICOS",
      title: "No hacemos marketing.",
      title2: "Diseñamos sistemas de crecimiento.",
      subtitle:
        "Seis disciplinas integradas en un único motor comercial — neurociencia, IA y ejecución medible.",
      explore: "Explorar",
      items: [
        {
          icon: "Brain",
          title: "Neuromarketing Aplicado",
          desc: "Mensajes diseñados con base en psicología del consumidor para activar decisiones de compra.",
          tag: "Neurociencia",
        },
        {
          icon: "Sparkles",
          title: "Inteligencia Artificial Estratégica",
          desc: "Automatizaciones inteligentes que optimizan procesos comerciales y escalan resultados.",
          tag: "IA Nativa",
        },
        {
          icon: "Target",
          title: "Estrategia Comercial 360°",
          desc: "Embudos, métricas y estructuras de seguimiento que convierten oportunidades en crecimiento sostenible.",
          tag: "Integral 360°",
        },
        {
          icon: "MessageSquare",
          title: "Automatización WhatsApp + CRM",
          desc: "Chatbots con IA, flujos automatizados y CRM conectado para atención y ventas 24/7.",
          tag: "Conversacional",
        },
        {
          icon: "Compass",
          title: "Posicionamiento de Marca",
          desc: "Definimos tu propuesta de valor y narrativa para competir por valor, no por precio.",
          tag: "Marca",
        },
        {
          icon: "Activity",
          title: "Coaching & Acompañamiento",
          desc: "No solo diseñamos la estrategia, la ejecutamos contigo hasta los resultados.",
          tag: "Acompañamiento",
        },
      ],
    },
    portfolio: {
      eyebrow: "CASOS REALES",
      title: "Estrategias que",
      title2: "se vuelven resultados.",
      subtitle:
        "Más de 14 años convirtiendo negocios en líderes de mercado. Estos son algunos de los sistemas que hemos diseñado e implementado.",
      filters: ["Todos", "IA", "Neuromarketing", "Estrategia", "Branding", "Coaching"],
    },
    about: {
      eyebrow: "QUIÉNES SOMOS",
      title: "Estrategia con base científica",
      title2: "y visión comercial.",
      p1: "En Reinvente integramos neuromarketing, inteligencia artificial y estrategia comercial 360° para diseñar sistemas de crecimiento sostenibles.",
      p2: "No hacemos marketing improvisado. Creamos estructuras que convierten tráfico en clientes y estrategia en resultados medibles.",
      founder: "Danny Sanclemente",
      founder_role: "Fundador & CEO",
      since: "Desde",
      skills: [
        { name: "Inteligencia Artificial", value: 100 },
        { name: "Coaching Comercial", value: 95 },
        { name: "Estrategia", value: 95 },
        { name: "Neuromarketing", value: 98 },
        { name: "Pasión", value: 100 },
      ],
    },
    process: {
      eyebrow: "MODELO DE TRANSFORMACIÓN",
      phase: "Fase",
      title: "Un sistema probado.",
      title2: "Menos teoría. Más estructura.",
      steps: [
        {
          n: "01",
          title: "Diagnóstico estratégico",
          desc: "Analizamos tu situación actual, métricas y oportunidades ocultas en tu operación comercial.",
        },
        {
          n: "02",
          title: "Diseño del sistema",
          desc: "Hoja de ruta personalizada con estrategia, IA, automatizaciones y herramientas necesarias.",
        },
        {
          n: "03",
          title: "Implementación & automatización",
          desc: "Desplegamos procesos, integramos IA, WhatsApp, CRM y optimizamos cada punto de contacto.",
        },
        {
          n: "04",
          title: "Optimización continua",
          desc: "Medimos, ajustamos y escalamos. Resultados sostenibles, no efímeros.",
        },
      ],
    },
    testimonials: {
      eyebrow: "RESULTADOS REALES",
      title: "Lo que dicen quienes",
      title2: "ya escalaron con nosotros.",
      items: [
        {
          quote:
            "Reinvente no solo mejoró nuestro marketing — estructuró todo el sistema comercial. Pasamos de operar sin claridad a tener métricas, embudos y automatizaciones con IA que generan resultados.",
          name: "Carlos M.",
          role: "Director Comercial",
        },
        {
          quote:
            "El enfoque de neuromarketing cambió completamente nuestra comunicación. Aumentamos la conversión y la percepción de marca en menos de tres meses.",
          name: "Laura G.",
          role: "CEO · Sector Salud",
        },
        {
          quote:
            "Antes hacíamos marketing sin dirección. Hoy tenemos un sistema claro, automatizado y medible. Reinvente realmente entiende cómo integrar IA con estrategia comercial.",
          name: "Andrés R.",
          role: "Empresario PyME",
        },
        {
          quote:
            "Duplicamos el valor de nuestros procedimientos en poco más de un año, consolidando la marca en un segmento premium.",
          name: "Julio V.",
          role: "Cirujano",
        },
      ],
    },
    cta: {
      eyebrow: "DIAGNÓSTICO ESTRATÉGICO",
      title: "Descubre en 30 minutos",
      title2: "qué está bloqueando tu crecimiento.",
      desc: "Una sesión sin costo donde analizamos tu situación comercial actual y te mostramos el camino para escalar — con IA, neuromarketing y estrategia 360°.",
      tags: ["Sin costo", "Sin compromiso", "100% estratégico"],
      button: "Agenda tu diagnóstico",
    },
    form: {
      title: "Agenda tu diagnóstico estratégico",
      sub: "Cuéntanos sobre tu negocio. Un estratega te contactará en menos de 24 horas.",
      name: "Nombre completo",
      email: "Correo corporativo",
      phone: "WhatsApp",
      company: "Empresa",
      interest: "¿En qué área necesitas crecer?",
      message: "¿Cuál es tu mayor reto comercial?",
      submit: "Enviar y agendar",
      submitting: "Enviando...",
      success_title: "Solicitud recibida",
      success_desc: "Un estratega te contactará pronto. Mientras tanto, explora nuestros casos de éxito.",
      error: "No pudimos enviar tu mensaje. Intenta de nuevo en unos segundos.",
      interests: [
        "Inteligencia Artificial",
        "Neuromarketing",
        "Estrategia comercial 360°",
        "Automatización WhatsApp + CRM",
        "Posicionamiento de marca",
        "Coaching comercial",
      ],
    },
    footer: {
      tagline: "Inteligencia comercial con base científica desde 2011.",
      explore: "Explorar",
      contact: "Contacto",
      legal: "Legal",
      rights: "Todos los derechos reservados.",
      privacy: "Privacidad",
      terms: "Términos",
      whatsapp: "Escríbenos por WhatsApp",
    },
    ticker: ["Inteligencia Artificial", "Neuromarketing", "Automatización", "Estrategia 360°", "WhatsApp + CRM", "Coaching Comercial", "Crecimiento Medible"],
  },
  en: {
    nav: {
      services: "Services",
      cases: "Case studies",
      about: "About",
      process: "Process",
      blog: "Resources",
      switch: "switch language",
      cta: "Book a consultation",
    },
    hero: {
      eyebrow: "Artificial Intelligence · Neuromarketing · 360° Strategy",
      title1: "The new standard",
      title2: "of commercial growth",
      title3: "powered by AI.",
      subtitle:
        "We integrate artificial intelligence, automation, marketing, sales and customer experience into a single system. Strategy with a human vision — executive-level results.",
      cta_primary: "Book a consultation",
      cta_secondary: "View case studies",
      stat1: "+14 years",
      stat1_label: "building market leaders",
      stat2: "+320%",
      stat2_label: "avg. conversion lift",
      stat3: "24/7",
      stat3_label: "AI + WhatsApp automation",
      scroll_hint: "scroll to activate the AI",
      act3_eyebrow: "· Ready for the next level ·",
      act3_title1: "Turn your business into a system",
      act3_title2: "powered by AI",
      badges: {
        b1: "+320% Conversion",
        b1_sub: "AI Funnel",
        b2: "AI Automation",
        b2_sub: "System live",
        b3: "Lead Intelligence",
        b3_sub: "Real-time scoring",
        b4: "WhatsApp AI",
        b4_sub: "Reply < 30s",
        b5: "CRM Connected",
        b5_sub: "In sync",
      },
    },
    services: {
      eyebrow: "STRATEGIC PILLARS",
      title: "We don't do marketing.",
      title2: "We design growth systems.",
      subtitle:
        "Six disciplines integrated in a single commercial engine — neuroscience, AI and measurable execution.",
      explore: "Explore",
      items: [
        { icon: "Brain", title: "Applied Neuromarketing", desc: "Messages designed on consumer psychology to trigger real buying decisions.", tag: "Neuroscience" },
        { icon: "Sparkles", title: "Strategic AI", desc: "Intelligent automations that optimize commercial processes and scale outcomes.", tag: "AI Native" },
        { icon: "Target", title: "360° Commercial Strategy", desc: "Funnels, metrics and tracking structures that turn opportunities into sustainable growth.", tag: "Full Stack" },
        { icon: "MessageSquare", title: "WhatsApp + CRM Automation", desc: "AI chatbots, automated flows and connected CRM for 24/7 sales & service.", tag: "Conversational" },
        { icon: "Compass", title: "Brand Positioning", desc: "We define your value proposition and narrative to compete on value, not on price.", tag: "Brand" },
        { icon: "Activity", title: "Coaching & Implementation", desc: "We don't only design the strategy — we execute it with you until results land.", tag: "Hands-on" },
      ],
    },
    portfolio: {
      eyebrow: "REAL CASES",
      title: "Strategies that",
      title2: "become results.",
      subtitle:
        "14+ years turning businesses into market leaders. Here are some of the systems we've designed and implemented.",
      filters: ["All", "AI", "Neuromarketing", "Strategy", "Branding", "Coaching"],
    },
    about: {
      eyebrow: "WHO WE ARE",
      title: "Strategy with scientific base",
      title2: "and commercial vision.",
      p1: "At Reinvente we integrate neuromarketing, artificial intelligence and 360° commercial strategy to design sustainable growth systems.",
      p2: "We don't improvise marketing. We build structures that turn traffic into customers and strategy into measurable results.",
      founder: "Danny Sanclemente",
      founder_role: "Founder & CEO",
      since: "Since",
      skills: [
        { name: "Artificial Intelligence", value: 100 },
        { name: "Sales Coaching", value: 95 },
        { name: "Strategy", value: 95 },
        { name: "Neuromarketing", value: 98 },
        { name: "Passion", value: 100 },
      ],
    },
    process: {
      eyebrow: "TRANSFORMATION MODEL",
      phase: "Phase",
      title: "A proven system.",
      title2: "Less theory. More structure.",
      steps: [
        { n: "01", title: "Strategic diagnosis", desc: "We analyze your current situation, metrics and hidden opportunities in your commercial operation." },
        { n: "02", title: "System design", desc: "Tailored roadmap with strategy, AI, automations and the right tooling." },
        { n: "03", title: "Implementation & automation", desc: "We deploy processes, integrate AI, WhatsApp, CRM and optimize every touchpoint." },
        { n: "04", title: "Continuous optimization", desc: "We measure, adjust and scale. Sustainable results, not fleeting wins." },
      ],
    },
    testimonials: {
      eyebrow: "REAL RESULTS",
      title: "What people say",
      title2: "after scaling with us.",
      items: [
        { quote: "Reinvente didn't just improve our marketing — it structured our entire commercial system. We went from operating without clarity to having metrics, funnels and AI automations that actually deliver.", name: "Carlos M.", role: "Sales Director" },
        { quote: "Their neuromarketing approach completely changed how we communicate. Conversion and brand perception increased in less than three months.", name: "Laura G.", role: "CEO · Healthcare" },
        { quote: "We used to run marketing without direction. Now we have a clear, automated and measurable system. Reinvente truly understands how to combine AI with commercial strategy.", name: "Andrés R.", role: "SMB Owner" },
        { quote: "We doubled the value of our procedures in just over a year, consolidating the brand in a premium segment.", name: "Julio V.", role: "Surgeon" },
      ],
    },
    cta: {
      eyebrow: "STRATEGIC DIAGNOSIS",
      title: "Find out in 30 minutes",
      title2: "what's blocking your growth.",
      desc: "A no-cost session where we analyze your current commercial situation and show you the path to scale — with AI, neuromarketing and 360° strategy.",
      tags: ["No cost", "No commitment", "100% strategic"],
      button: "Book your diagnosis",
    },
    form: {
      title: "Book your strategic diagnosis",
      sub: "Tell us about your business. A strategist will reach out in under 24 hours.",
      name: "Full name",
      email: "Business email",
      phone: "WhatsApp",
      company: "Company",
      interest: "Which area do you need to grow?",
      message: "What's your biggest commercial challenge?",
      submit: "Send & book",
      submitting: "Sending...",
      success_title: "Request received",
      success_desc: "A strategist will contact you shortly. Meanwhile, explore our case studies.",
      error: "We couldn't send your message. Please try again in a few seconds.",
      interests: ["Artificial Intelligence", "Neuromarketing", "360° Commercial Strategy", "WhatsApp + CRM Automation", "Brand positioning", "Sales coaching"],
    },
    footer: {
      tagline: "Commercial intelligence with scientific base since 2011.",
      explore: "Explore",
      contact: "Contact",
      legal: "Legal",
      rights: "All rights reserved.",
      privacy: "Privacy",
      terms: "Terms",
      whatsapp: "Message us on WhatsApp",
    },
    ticker: ["Artificial Intelligence", "Neuromarketing", "Automation", "360° Strategy", "WhatsApp + CRM", "Sales Coaching", "Measurable Growth"],
  },
};

export const LOGO_URL = "https://reinventemercadeo.com/wp-content/uploads/2026/03/LOGO-REINVENTE-COMPLETO-60X60-ROUND-CORNERS.png";
export const HERO_VIDEO = "/media/brain.mp4";
export const FOUNDER_IMG = "https://reinventemercadeo.com/wp-content/uploads/2026/03/DANNY-AI-LIGHTS.png";
